import script from "./selectCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./selectCompany.vue?vue&type=script&setup=true&lang=js"

import "./selectCompany.vue?vue&type=style&index=0&id=96d626fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96d626fa"]])

export default __exports__